(function () {
  'use strict';
  function boot() {
    var launch = document.querySelector('[data-tb-viewer-launch]');
    var title = document.querySelector('.product__title') || document.querySelector('#MainContent h1');
    if (!launch || !title || launch.dataset.bound) return;
    launch.dataset.bound = 'true';
    title.insertAdjacentElement('afterend', launch);
    launch.hidden = false;
    var link = launch.querySelector('a.tb-viewer-launch');
    var info = title.closest('product-info') || title.closest('[id^="ProductInfo-"]');
    if (!link || !info) return;
    function syncVariant() {
      var selected = info.querySelector('variant-selects script[type="application/json"]');
      var variant;
      if (selected) {
        try { variant = JSON.parse(selected.textContent).id; } catch (_) {}
      }
      if (!variant) {
        var input = info.querySelector('form[action*="/cart/add"] input[name="id"]');
        variant = input && input.value;
      }
      if (!variant) return;
      var url = new URL(link.href, window.location.href);
      url.searchParams.set('variant', variant);
      url.searchParams.set('view', 'trobart-viewer');
      if (link.href !== url.href) link.href = url.href;
    }
    syncVariant();
    // Dawn replaces the selected-variant JSON after a size change.
    new MutationObserver(syncVariant).observe(info, {childList:true, subtree:true});
    link.addEventListener('click', syncVariant);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
